<template>
  <Tab @close="removeCurrent">
    <template #toolbar-items>
      <!-- ------------------------ groups ------------------------ -->
      <TabToolbarButton
        v-model="page"
        :menu="menu"
        :selected="page == 'groups'"
        icon="fa-users"
        name="groups"
      ></TabToolbarButton>
    </template>
    <template #container>
      <div class="sr-container">
        <div v-if="group && false" style="max-height: 35vh;overflow: auto">
          <b>search</b> - {{ search }}<br /><br />
          <b>users</b> - {{ users }}<br /><br />
          <b>members</b> - {{ members }}<br /><br />
          <b>user</b> - {{ user }}<br /><br />
          <b>groups</b> - {{ groups }}<br /><br />
          <b>group</b> - {{ group }}<br /><br />
          <b>userIsAdmin</b> - {{ userIsAdmin }}<br /><br />
          <b>usersAndMembers</b> - {{ usersAndMembers }}<br /><br />
          <b>authenticatedUser</b> - {{ authenticatedUser }}<br /><br />
        </div>

        <!-- ------------------------ groups ------------------------ -->
        <TabPage :menu="menu" :page="page" documentation-path="me/groups/page" name="groups">
          <template #content>
            <div class="sr-title tw-mb-4">
              {{ $t("groups.form.title") }}
            </div>

            <Form ref="newgroup" :callback="addUserGroup">
              <FormField
                v-model="form.group"
                :props="{
                  hideDetails: true,
                  class: 'sr-inline-form-align',
                }"
                input-type="text"
              >
                <template #append-outer>
                  <v-btn color="primary" @click="$refs.newgroup.validate()">
                    {{ $t("groups.form.add") }}
                  </v-btn>
                </template>
              </FormField>
            </Form>

            <v-list avatar>
              <v-list-item-group class="tw-border tw-rounded">
                <v-list-item
                  v-for="g in groups"
                  :key="g.id + g.database"
                  :title="$t('menu.groups.edit')"
                  @click="setCurrentGroup(g)"
                >
                  <v-list-item-avatar>
                    <v-img
                      :src="g.avatar"
                      lazy-src="https://cdn.securating.io/public/storage/shared/boffice/v1.0/securating_transparent.png"
                    ></v-img>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title v-text="g.group"></v-list-item-title>
                    <v-list-item-subtitle v-text="g.description"></v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action v-if="g === group && members.length === 1">
                    <v-btn :title="$t('menu.groups.remove')" icon @click="removeGroup(g)">
                      <v-icon color="orange" small>fa-trash-alt</v-icon>
                    </v-btn>
                  </v-list-item-action>
                  <v-list-item-action>
                    <v-btn icon>
                      <v-icon v-if="g !== group" small>fa-angle-right</v-icon>
                      <v-icon v-else small>fa-angle-left</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </template>
          <template v-if="group" #rightWithOutHelp>
            <!-- Group's Information  -->
            <v-row>
              <!-- Group's Information in case current user is the GroupdAdmin -->
              <v-col v-if="userIsAdmin">
                <AvatarField
                  ref="avatarForAdmin"
                  :src="getAvatar"
                  i18n="menu.groups.editing.avatar"
                  with-upload
                  @uploaded="updateGroupAvatar"
                />
                <v-text-field
                  v-model="group.group"
                  :label="$t('menu.groups.editing.title')"
                  @input="setUpdateTimeout"
                ></v-text-field>
                <v-text-field
                  v-model="group.description"
                  :label="$t('menu.groups.editing.description')"
                  @input="setUpdateTimeout"
                ></v-text-field>
              </v-col>
              <!-- Group's Information in case current user is only a Group member -->
              <v-col v-else>
                <AvatarField
                  ref="avatarForNotAdmin"
                  :src="getAvatar"
                  i18n="menu.groups.editing.avatar"
                  with-upload="false"
                />
                <v-text-field v-model="group.group" :label="$t('menu.groups.editing.title')" disabled></v-text-field>
                <v-text-field
                  v-model="group.description"
                  :label="$t('menu.groups.editing.description')"
                  disabled
                ></v-text-field>
                <v-btn color="error" small @click="leaveGroup()">{{ $t("menu.groups.leave") }}</v-btn>
              </v-col>
            </v-row>
            <!-- Group's Members list-->
            <v-row>
              <v-col>
                <div class="tw-mt-4">{{ $t("menu.groups.members") }}</div>
                <v-list avatar>
                  <v-list-item-group class="tw-border tw-rounded">
                    <v-list-item v-for="u in members" :key="u.id + u.database">
                      <v-list-item-avatar>
                        <v-img :src="u.avatar"></v-img>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title v-text="`@${u.user_name}`"></v-list-item-title>
                        <v-list-item-subtitle> {{ u.first_name }} {{ u.last_name }}</v-list-item-subtitle>
                      </v-list-item-content>

                      <!-- Show the admin of this group -->
                      <v-list-item-action v-if="memberIsAdmin(u)" :title="$t('menu.groups.admin')">
                        <v-btn
                          v-if="members.filter(m => m.id === u.id).length > 0"
                          :title="$t('menu.groups.isAdmin')"
                          icon
                        >
                          <v-icon small>fa-crown</v-icon>
                        </v-btn>
                      </v-list-item-action>

                      <v-list-item-action v-else>
                        <v-btn v-if="userIsAdmin" :title="$t('menu.groups.promote')" icon @click="promoteMember(u)">
                          <v-icon small>fa-user-cog</v-icon>
                        </v-btn>
                      </v-list-item-action>
                      <!-- Permit to Remove member of this group if current user is admin -->
                      <v-list-item-action v-if="userIsAdmin">
                        <v-btn v-if="memberIsAdmin(u)" disabled icon>
                          <v-icon color="grey" small>
                            fa-minus-circle
                          </v-icon>
                        </v-btn>
                        <v-btn v-else :title="$t('menu.groups.remove')" icon @click="removeMember(u)">
                          <v-icon color="orange" small>
                            fa-minus-circle
                          </v-icon>
                        </v-btn>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-col>
            </v-row>
            <!-- User to add list-->
            <v-row v-if="userIsAdmin">
              <v-col>
                <v-list avatar>
                  <v-text-field
                    v-model="search"
                    :label="$t('menu.groups.editing.members')"
                    color="grey"
                    filled
                    single-line
                    @input="setSearchingTimeout"
                  >
                    <template #prepend-inner>
                      <v-icon left small>fa-search</v-icon>
                    </template>
                    <template v-if="search.length > 0" #append>
                      <v-icon
                        right
                        small
                        @click="
                          search = ''
                          users = null
                        "
                        >fa-times
                      </v-icon>
                    </template>
                  </v-text-field>
                  <v-list-item-group class="tw-border tw-rounded tw-rounded-t-none">
                    <v-list-item v-for="u in users" :key="u.id + u.database" @click="addMember(u)">
                      <v-list-item-avatar>
                        <v-img :src="u.avatar"></v-img>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title v-text="`@${u.user_name}`"></v-list-item-title>
                        <v-list-item-subtitle> {{ u.first_name }} {{ u.last_name }}</v-list-item-subtitle>
                      </v-list-item-content>

                      <!-- User is member of the group or not -->
                      <v-list-item-action>
                        <v-btn :title="$t('menu.groups.add')" icon>
                          <v-icon small>
                            fa-plus-circle
                          </v-icon>
                        </v-btn>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-col>
            </v-row>
          </template>
        </TabPage>
      </div>
    </template>
  </Tab>
</template>

<script>
import tab from "../../../../mixins/tab"
import { Types } from "@/store/modules/snackbar"
import { Types as TypesLoading } from "@/store/modules/loading"

export default {
  name: "Groups",
  mixins: [tab],
  data: () => ({
    menu: "menu",
    pages: ["groups"],
    page: "groups",
    searchingTimeoutHandler: null,
    updateTimeoutHandler: null,
    search: "",
    users: [],
    members: [],
    user: null,
    groups: [],
    group: null,
    form: {},
  }),
  mounted() {
    this.fetchGroups()
  },
  methods: {
    addUserGroup() {
      return new Promise((resolve, reject) => {
        //if (!this.groups.some(group => group.description === this.form.group)) {
        this.$axios
          .post("/office/me/groups/add", this.form)
          .then(response => {
            // Push the new website on the table
            this.groups = response.data.data
            this.form = {}
            resolve()
          })
          .catch(errors => {
            reject(errors.response.data)
          })
        //}
      })
    },
    setSearchingTimeout() {
      if (this.searchingTimeoutHandler !== null) {
        window.clearTimeout(this.searchingTimeoutHandler)
      }
      this.searchingTimeoutHandler = window.setTimeout(() => {
        this.fetchUsers()
      }, 1000 * 1.2)
    },
    setUpdateTimeout() {
      if (this.updateTimeoutHandler !== null) {
        window.clearTimeout(this.updateTimeoutHandler)
      }
      this.updateTimeoutHandler = window.setTimeout(() => {
        this.updateGroup()
      }, 1000 * 0.5)
    },
    fetchUsers() {
      if (this.search.trim().length > 0) {
        this.$axios
          .get(`/office/me/users?search=${encodeURIComponent(this.search.trim())}`, {
            params: {
              ids: [...this.members.map(m => m.id), this.$store.state.auth.user.id],
            },
          })
          .then(response => {
            this.users = response.data.data
          })
      }
    },
    fetchMembers() {
      this.members = []
      this.$axios.get(`/office/me/groups/members/${this.group.id}`).then(response => {
        this.members = response.data.data
      })
    },
    fetchGroups() {
      this.$store.commit(TypesLoading.mutations.LOADING_YES)
      this.$axios
        .get("/office/me/groups")
        .then(response => {
          this.groups = response.data
        })
        .finally(() => this.$store.commit(TypesLoading.mutations.LOADING_NO))
    },
    setCurrentGroup(group) {
      this.members = []
      this.users = []
      this.search = ""
      if (this.group !== group) {
        this.group = group
        if (this.$refs.avatarForAdmin) this.$refs.avatarForAdmin.setImageSrc(this.group.avatar)
        if (this.$refs.avatarNotForAdmin) this.$refs.avatarNotForAdmin.setImageSrc(this.group.avatar)
        this.fetchMembers()
      } else {
        this.group = null
      }
    },
    memberIsAdmin(user) {
      return user.id === this.group.admin_id
    },
    addMember(user) {
      this.$axios
        .post("/office/me/groups/user/add", {
          user_id: user.id,
          group_id: this.group.id,
        })
        .then(() => {
          user.group_ids.push(this.group.id)
          this.members.push(user)
          this.users = this.users.filter(u => u.id !== user.id)
        })
    },
    promoteMember(user) {
      this.$axios
        .post("/office/me/groups/user/promote", {
          user_id: user.id,
          group_id: this.group.id,
        })
        .then(() => {
          this.group.admin_id = user.id
        })
    },
    removeMember(user) {
      this.$axios
        .post("/office/me/groups/user/remove", {
          user_id: user.id,
          group_id: this.group.id,
        })
        .then(() => {
          user.group_ids = user.group_ids.filter(id => id !== this.group.id)
          this.users.push(user)
          this.members = this.members.filter(m => m.id !== user.id)
        })
    },
    leaveGroup() {
      this.$axios
        .post("/office/me/groups/user/leave", {
          user_id: this.authenticatedUser.id,
          group_id: this.group.id,
        })
        .then(() => {
          this.groups = this.groups.filter(g => g.id !== this.group.id)
          this.group = null
        })
    },
    updateGroupAvatar(image) {
      this.group.avatar = image.url
      return this.updateGroup()
    },
    async removeGroup(group) {
      let doRemove = true
      if (this.members.length !== 1) {
        doRemove = false
      }

      if (doRemove) {
        await this.$axios.post("/office/me/groups/remove", group).then(() => {
          this.groups = this.groups.filter(g => g.id !== group.id)
          this.group = null
        })
      }
    },
    updateGroup() {
      this.$axios.post("/office/me/groups/update", this.group).then(() => {
        this.$store.dispatch(Types.actions.PUSH_MESSAGE, {
          lines: this.$t("menu.groups.updated"),
          config: { timeout: 1000 * 2, color: "dark" },
        })
      })
    },
  },
  computed: {
    getAvatar() {
      return this.group.avatar
    },
    userIsAdmin() {
      return this.$store.state.auth.user.id === this.group.admin_id
    },
    usersAndMembers() {
      const um = [...this.users, ...this.members]

      return um.sort((a, b) => {
        if (a.id < b.id) {
          return -1
        } else if (a.id > b.id) {
          return 1
        } else {
          return 0
        }
      })
    },

    authenticatedUser() {
      return this.usersAndMembers.find(u => u.id === this.$store.state.auth.user.id)
    },
  },
}
</script>
